"use strict";

exports.__esModule = true;
exports.manualDataUpdate = manualDataUpdate;
var _intersection2 = _interopRequireDefault(require("ramda/src/intersection"));
var _path2 = _interopRequireDefault(require("ramda/src/path"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function sortData(columns, sorted, result) {
  var column = columns.find(function (column) {
    return column.accessor === sorted[0].id;
  });
  var sortMethod = column && column.sortMethod ? column.sortMethod : null;
  var id = column ? column.accessor : "";

  // $FlowIgnore
  if (id && sortMethod && column.type === "lookUpForTypeInRow") {
    var ascending = result.sort(function (a, b) {
      return sortMethod(a[id], b[id]);
    });
    result = sorted[0].desc ? ascending.reverse() : ascending;
  } else if (id && column && column.type && column.sorter) {
    var _ascending = result.sort(function (a, b) {
      var colPath = id.split(".");
      var fn = typeof column.sorter === "function" ? column.sorter : column.sorter[column.type];
      var valA = (0, _path2["default"])(colPath, a);
      var valB = (0, _path2["default"])(colPath, b);
      return typeof fn === "function" ? fn(valA, valB) : 0;
    });
    result = sorted[0].desc ? _ascending.reverse() : _ascending;
  } else if (column && id && sortMethod) {
    var _ascending2 = result.sort(function (a, b) {
      var valA = (0, _path2["default"])(id.split("."), a);
      var valB = (0, _path2["default"])(id.split("."), b);
      return sortMethod(valA, valB);
    });
    result = sorted[0].desc ? _ascending2.reverse() : _ascending2;
  }
  return result;
}
function filterData(data, filtered, columnsFastFind) {
  return data.filter(function (row) {
    if (!filtered.length) {
      return true;
    }
    return filtered.every(function (filter) {
      var id = filter.id,
        filterValue = filter.value;
      var rowValue = (0, _path2["default"])(id.split("."), row);
      var columnCell = columnsFastFind[id] && columnsFastFind[id].Cell ? columnsFastFind[id].cellFormatter : null;
      if (typeof filterValue === "string") {
        if (filterValue.trim().length === 0) {
          return true;
        }
        var cellValue = columnCell ? columnCell({
          value: rowValue
        }) : columnCell;
        return !!(cellValue || "").toLowerCase().includes(filterValue.toLowerCase());
      }
      if (Array.isArray(filterValue) && !filterValue.length) {
        return true;
      }
      return Array.isArray(rowValue) ? (0, _intersection2["default"])(rowValue.map(function (val) {
        return val.value || val;
      }), filterValue).length : filterValue.includes(rowValue);
    });
  });
}
function filterDataByText(data, searchTerm, columnsFastFind) {
  if (searchTerm === void 0) {
    searchTerm = "";
  }
  return data.filter(function (row) {
    var columnTypes = Object.keys(columnsFastFind);
    return columnTypes.some(function (id) {
      var _columnsFastFind$id;
      var rowValue = (0, _path2["default"])(id.split("."), row);
      var columnCell = columnsFastFind[id] && columnsFastFind[id].Cell ? columnsFastFind[id].cellFormatter : null;
      var cellValue = columnCell ? columnCell({
        value: rowValue
      }) : columnCell;
      cellValue = (_columnsFastFind$id = columnsFastFind[id]) != null && _columnsFastFind$id.useRowValue ? rowValue : cellValue;
      if (typeof cellValue === "number") {
        cellValue = cellValue.toString();
      }
      if (typeof cellValue === "object") {
        if (Array.isArray(cellValue)) {
          return cellValue.map(function (val) {
            return val.value || val;
          }).some(function (item) {
            if (typeof item === "number") {
              item = item.toString();
            }
            if (typeof item === "object") {
              return;
            }
            return !!(item || "").toLowerCase().includes(searchTerm.toLowerCase());
          });
        } else {
          return;
        }
      }
      return !!(cellValue || "").toLowerCase().includes(searchTerm.toLowerCase());
    });
  });
}
function manualDataUpdate(columns, data, sorted, filtered, searchTerm) {
  if (searchTerm === void 0) {
    searchTerm = "";
  }
  var columnsFastFind = columns.reduce(function (acc, column) {
    acc[column.accessor] = column;
    return acc;
  }, {});
  var result = filterData(data, filtered, columnsFastFind);
  if (searchTerm) {
    result = filterDataByText(result, searchTerm, columnsFastFind);
  }
  if (sorted.length) {
    result = sortData(columns, sorted, result);
  }
  return result;
}